import { Button, HStack, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

const money = new Intl.NumberFormat('es-UY', { style: 'currency', currency: 'UYU' });

function StudentShortcuts({ row }) {
  const navigate = useNavigate();
  const personId = row.id;
  const studentId = row.student?.id;

  return (
    <HStack spacing={2}>
      <Button
        size="xs"
        variant="outline"
        colorScheme="blue"
        onClick={() => navigate(`/admin/default/${personId}?tab=escolaridad`)}
      >
        Escolaridad
      </Button>
      <Button
        size="xs"
        variant="outline"
        colorScheme="teal"
        isDisabled={!studentId}
        onClick={() => navigate(`/admin/current-account?studentId=${studentId}`)}
      >
        Cuenta corriente
      </Button>
    </HStack>
  );
}

export const columnsDataStudents = [
  {
    Header: "Documento",
    accessor: "document",
  },
  {
    Header: "Apellidos",
    accessor: "lastNames",
    computedValue: (row) => `${row.lastName || ''} ${row.maternalLastName || ''}`.trim(),
  },
  {
    Header: "Nombres",
    accessor: "names",
    computedValue: (row) => `${row.name || ''} ${row.secondName || ''}`.trim(),
  },
  {
    Header: "Mail",
    accessor: "email",
  },
  {
    Header: "Celular",
    accessor: "cellPhone",
  },
  {
    Header: "Cuenta corriente",
    accessor: "currentAccountBalance",
    Cell: ({ row }) => {
      const value = Number(row.original.currentAccountBalance || 0);
      return (
        <Text fontSize="sm" fontWeight="700" color={value > 0 ? 'red.500' : 'green.600'}>
          {money.format(value)}
        </Text>
      );
    },
  },
  {
    Header: "Accesos",
    accessor: "shortcuts",
    Cell: ({ row }) => <StudentShortcuts row={row.original} />,
  },
];
